export default __webpack_public_path__ + "static/media/T_65_desktop.3675da90.jpg";